










import pageMixin from '@bkwld/cloak/mixins/page'
import getCraftPages from '~/queries/craft-pages.gql'
import getRedirects from '~/queries/get-redirects.gql'
export default

	mixins: [ pageMixin ]

	props: ['error']

	data: ->
		page: null
		redirects: []

	fetch: ->

		# Get get the page data
		[ @page ] = await @$craft.getEntries
			query: getCraftPages
			variables:
				section: 'towers'
				type: 'towers'
				uri: @uri

		# Fetch all of the redirects, in case this page should normally client side
		# redirect.
		@redirects = await @$craft.getEntries query: getRedirects

	mounted: -> @showSentryDialog() if @uri == 'error'

	computed:

		# Figure out which error tower to show
		uri: -> switch @error?.statusCode
			when 404 then 'page-not-found'
			else 'error'

	watch:

		# When redirects is set (which may be after mounted when SPAing)
		redirects:
			immediate: true
			handler: -> @redirectIfMatch()

	methods:

		# If the current path matches the redirect "from", then redirect
		redirectIfMatch: ->
			if match = @redirects.find ({ from }) => from == @$route.path
			then location.href = match.to

		# Show the sentry dialog
		# https://docs.sentry.io/enriching-error-data/user-feedback/?platform=browser
		showSentryDialog: -> @$defer => @$sentry?.showReportDialog()

